import { render } from "./Options.vue?vue&type=template&id=922e4c8c&scoped=true"
import script from "./Options.vue?vue&type=script&lang=js"
export * from "./Options.vue?vue&type=script&lang=js"

import "./Options.vue?vue&type=style&index=0&id=922e4c8c&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-922e4c8c"]])

export default __exports__